// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ChecklistController from "./checklist_controller"
application.register("checklist", ChecklistController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OutletSyncController from "./outlet_sync_controller"
application.register("outlet-sync", OutletSyncController)

import OutletSyncToastController from "./outlet_sync_toast_controller"
application.register("outlet-sync-toast", OutletSyncToastController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import RevealSecretController from "./reveal_secret_controller"
application.register("reveal-secret", RevealSecretController)

import RoleCheckboxController from "./role_checkbox_controller"
application.register("role-checkbox", RoleCheckboxController)

import SalesChartController from "./sales_chart_controller"
application.register("sales-chart", SalesChartController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
